import { ApiUrl } from "../constants/api_url"
import AxiosHelper from "../helper/axiosHelper"

export async function createNewSecretKey() {
    return await AxiosHelper.post(`${ApiUrl.EXPORT_DATA}/generate-api-key`)
}